import React from "react";

const BottomFooter = () => {
  const currentYear = new Date().getFullYear(); // Get current year dynamically
  return (
    <div className="bottom-footer site-footer__bottom">
      <div className="container container-lg">
        <p className="m-0">
          Copyright © {currentYear}. Bigmall PLC All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default BottomFooter;
